// extracted by mini-css-extract-plugin
export default {"container":"Vaa-z","oos":"Waa-z","oosUx":"Xaa-z","selected":"Yaa-z","labelOos":"Zaa-z"};